<template>
  <v-bottom-navigation lazy grow fixed class="hidden-sm-and-up" v-model="page" :value="true" background-color="white">
    <v-btn color="primary" text value="Dashboard">
      <span>{{lang.dashboard}}</span>
      <v-icon>dashboard</v-icon>
    </v-btn>

    <v-btn color="primary" text value="Users">
      <span>{{lang.users}}</span>
      <v-icon>account_circle</v-icon>
    </v-btn>

    <v-btn color="primary" text value="Coupons">
      <span>{{lang.coupons}}</span>
      <v-icon>card_membership</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    page: "dashboard",
    active: false
  }),
  computed: {
    ...mapState(["lang", "page_name"])
  },
  watch: {
    page: function(val) {
      if (!this.active) return;
      switch (val) {
        case "Dashboard":
          this.changePage("/");
          break;
        case "Users":
          this.changePage("/users");
          break;
        case "Coupons":
          this.changePage("/coupons");
          break;
      }
    }
  },
  mounted() {
    this.page = this.page_name;
    this.active = true;
  },
  methods: {
    changePage(path) {
      window.getApp.$router.replace({ path: path });
    }
  }
};
</script>